"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const fa_1 = require("react-icons/fa");
const sortIconStyle = {
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    left: '2px',
};
function ReactTableHeader({ headerGroups, onClick }) {
    return ((0, jsx_runtime_1.jsx)("thead", { children: headerGroups.map((headerGroup) => {
            const { key: headerGroupKey, ...restHeaderGroupProps } = headerGroup.getHeaderGroupProps();
            return ((0, jsx_runtime_1.jsx)("tr", { ...restHeaderGroupProps, children: headerGroup.headers.map((column) => ((0, jsx_runtime_1.jsx)(HeaderCell, { column: column, onClick: onClick }, column.getHeaderProps(column.getSortByToggleProps()).key))) }, headerGroupKey));
        }) }));
}
const HeaderCell = (props) => {
    const { column } = props;
    const { key: headerKey, style: headerStyle, onClick, ...restHeaderProps } = column.getHeaderProps(column.getSortByToggleProps());
    function clickHandler(e) {
        if (onClick) {
            onClick(e);
            props.onClick(e);
        }
    }
    return ((0, jsx_runtime_1.jsxs)("th", { ...restHeaderProps, style: { ...headerStyle, ...column.style, height: '1px' }, onClick: clickHandler, children: [(0, jsx_runtime_1.jsx)("span", { style: sortIconStyle, children: column.isSorted ? (column.isSortedDesc ? ((0, jsx_runtime_1.jsx)(fa_1.FaSortAmountDown, {})) : ((0, jsx_runtime_1.jsx)(fa_1.FaSortAmountUp, {}))) : ('') }), column?.render('Header')] }, headerKey));
};
exports.default = ReactTableHeader;
